var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-section",
    {
      attrs: { id: "checkout", title: "Buchung abschließen", contentClass: "" }
    },
    [
      _vm.loaded
        ? _c(
            "div",
            {
              staticClass: "booking__checkout",
              attrs: { id: "booking_services_table" }
            },
            [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.result.checkout_view) }
              })
            ]
          )
        : _c("loader", {
            attrs: {
              title: "Ihre Buchung wird vorbereitet",
              details: "Einen Moment bitte"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }